<script setup lang="ts">
import { ICONS, type IconName, type IconWeight } from '@/constants/app/icon.constant.js'

/**
 * The only icon renderer. Reads the closed registry in `constants/app/icon.constant.ts`.
 *
 * Inline `<svg>` is lint-banned outside `components/base/`, and this component is why the
 * ban costs nothing: an icon is one attribute, `name`, and the registry type makes a typo a
 * build failure rather than an empty box.
 *
 * `aria-hidden` always. An icon beside a label is decoration; an icon that *is* the label
 * (an icon-only button) gets its accessible name from the control, via `aria-label`, not
 * from the glyph. `currentColor` is inherited, so an icon takes the colour of whatever it
 * sits in and needs no variant of its own.
 */
withDefaults(defineProps<{ name: IconName; size?: number; weight?: IconWeight }>(), {
  size: 20,
  weight: 'regular',
})
</script>

<template>
  <component
    :is="ICONS[name]"
    :size="size"
    :weight="weight"
    color="currentColor"
    aria-hidden="true"
  />
</template>
